import React from "react";

type Props = {
    className?  : string,
    style?      : style
}

export default function ErrorRender(props: Props) {

    return (
        <div className={Classes("gd-error-boundary", props.className)} style={props.style}>Rendering error. Try refreshing the page / re-login. If you still see the error message please report the issue.</div>
    )
}
